
export const REST_SERVER_URL: string = 'https://ws.archismall.com';
export const DEBUG: boolean = false;
export const TAG: string = 'v2.27.8';
export const ENV_NAME: string = 'Production';
export const STORAGE_BUCKET: string = 'l001cons';
export const TMP_BUCKET: string = 'l001tmp';
export const RABBIT_SERVERS_URL: Array<any> = ['wss://rb.archismall.com/ws', ];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/config.ts